import React from "react";
import gifs from "../../../assets/icons/gifs.json";
import { SuccessMessageProps } from "./SuccessMessageInterface";
import { useAuth } from "../../../context/AuthContext";

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  message = "Congratulations!",
  description = "Tu plan ha sido actualizado correctamente",
  imageSrc = gifs.success,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
      }}
    >
      <div
        style={{
          width: 125.95,
          height: 125.95,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          style={{ width: 124.9, height: 124.9 }}
          src={imageSrc}
          alt="success-icon"
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 5,
        }}
      >
        <div
          style={{
            width: 214.86,
            textAlign: "center",
            color: "#2C3BA9",
            fontSize: 20,
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 700,
            lineHeight: "26px",
          }}
        >
          {message}
        </div>
        <div
          style={{
            marginTop: 10,
            width: 214.86,
            textAlign: "center",
            color: "#2C3BA9",
            fontSize: 16,
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 500,
            lineHeight: "20px",
            letterSpacing: 0.15,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
            textDecorationColor: "#2C3BA9",
          }}
        >
          <a href={description} target="_blank" rel="noopener noreferrer">
            {description}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;
